import React,{useEffect, useState} from 'react'
import { useSearchParams } from 'react-router-dom'
import axios from 'axios';
import { baseURL } from '../../axiosInstance';
import { Button, IconButton } from '@mui/material';
import Swal from 'sweetalert2';
import { useMediaQuery } from '@mui/material';


function DisturbutorEditForm() {
          const isMobile = useMediaQuery('(max-width:600px)');
          

          const [distdetails] =useSearchParams()
           console.log("edtt para",distdetails)
           const disid = distdetails.get('disid')
           console.log(" disid ", disid )
           console.log("edit para parentid",disid)
           const token = distdetails.get('token')
           const parentid = distdetails.get('parentid')
           const type = distdetails.get("type")
         
           const disemail  = distdetails.get('email')
           const [formData, setFormData] = useState({
            parent_id:parentid,
            type:type,
       
            name: '',
            username:'',
            
            password: '',
            email: '',
            phone: '',
            address: '',
            language:'',
          });

          const [showPasswordField, setShowPasswordField] = useState(false);


        const fetchdata =  async()=> {

            try {
                const res= await axios.get(`${baseURL}/distributor/${disid}`,{
                    headers:{
                        Authorization: `Bearer ${token}`,
                        Accept:'application/json',
                        identifier:disemail
        
        
                    }
                })
                const resdata = res.data.data 
                console.log(" resdata", resdata)
                // setFormData((prev)=> ({
                //     ...prev,
                //     ...resdata
                // }))
                const filteredData = Object.keys(formData).reduce((acc, key) => {
                  acc[key] = resdata[key] ?? ''; // Use nullish coalescing to prevent undefined values
                  return acc;
                }, {});
            
                setFormData(filteredData);
                // setFormData(resdata)
                if (resdata.password === null) {
                  setShowPasswordField(true);
                }
        
        
            }
            catch(error){
                console.log("error",error)
            }
        
          }

          useEffect(()=> {
            fetchdata()
          },[])

          const handleChange = (e) => {
            const { name, value, type } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: type === 'radio' ? Number(value) : value,
            }));
          };

          const handleSubmit = async (e) => {
            e.preventDefault();
            const filteredData= Object.keys(formData).reduce((acc, key) => {
              if (formData[key] !== "" && formData[key] !== null && formData[key] !== undefined) {
                acc[key] = formData[key];
              }
              return acc;
            }, {});
            try {
              if(disid){
                // const apiClient = axios.create({
                //   baseURL: baseURL,
                //   headers: {
                //     Authorization: `Bearer ${params.token}`,
                //     Accept: 'application/json',
                //     identifier: params.disemail
                //   }
                // });
                
                // const res = await apiClient.put(`/distributor/${clientid}`, { ...filteredData });
                const res = await axios.put(
                  `${baseURL}/distributor/${disid}`,
                  { ...filteredData },
                  {
                    headers: {
                      Authorization: `Bearer ${token}`,
                      Accept: 'application/json',
                      identifier: disemail
                    }
                  }
                );
          
                console.log("edit res",res)
                  if (res.status === 200) {
                            // alert('Client added successfully!');
                            Swal.fire('Success!', 'Disturbtor updated successfully!', 'success');
                  
                          }
                
          
                
              }
        
              // Reset form
              // setFormData({ parent_id:parentid, type: type, name: '', password: '', email: '', phone: '', address: '' });
            } catch (error) {
              // alert(`Error: ${error?.response?.data?.error}`);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: error?.response?.data?.error || "Something went wrong!",
              });
              console.error(error);
            }
          };
        
  return (
    <div className='distributerbgimage rounded-3 shadow d-flex justify-content-center align-items-center vh-100 p-4'>
    <div className='p-4 shadow rounded-5  h-100 overflow-y-auto' style={{ width: "900px" ,maxHeight:"500px",overflow:"auto"}}>
      <form onSubmit={handleSubmit}>
        <div className='row' >
        {[
          { label: 'Name', name: 'name', type: 'text', required: true },
          { label: 'Phone Number', name: 'phone', type: 'text',required:true},


         
          ].map((field) => (
          <div key={field.name} className='col-md-6 col-12'>
            <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
            <input
              className='form-control'
              name={field.name}
              type={field.type}
              placeholder={field.label}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          </div>
        ))}
         {[
         

        
          { label: 'Email', name: 'email', type: 'email', required:true},
          ].map((field) => (
            <>
          <div key={field.name} className='col-md-6 col-12'>
            <label htmlFor={field.name} className='form-label distributerfont'>{field.label}</label>
            <input
              className='form-control'
              name={field.name}
              type={field.type}
              placeholder={field.label}
              value={formData[field.name]}
              onChange={handleChange}
              required={field.required}
            />
          </div>
         
          </>
        ))}
          {showPasswordField && (
            <div className='col-md-6 col-12'>
              <label htmlFor='password' className='form-label distributerfont'>Password</label>
              <input
                className='form-control'
                name='password'
                type='password'
                placeholder='Password'
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>
          )}
          </div>
          <div className='col-md-6 col-12'>
            <label htmlFor='address' className='form-label distributerfont'>Address</label>
            <textarea
            className='form-control'
            name="address"
            type="text"
            value={formData.address}
            onChange={handleChange}
            />
          </div>
          <div className='d-flex justify-content-center align-items-center py-2 ' style={{ marginTop: isMobile ? "4rem" : "8rem" }}>
          <Button variant="outlined" color="secondary" >Cancel</Button>
          <Button type='submit' variant="contained" color="primary" className='m-1'>
             Submit
          </Button>
        </div>
      </form>
    </div>
  </div>
  )
}

export default DisturbutorEditForm